import '../view-loader';
import 'ShopUiBundle/components/molecules/text-input';
import './style.scss';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('search-box', () => import(/* webpackMode: "lazy" */'./search-box'));
